import { Card, Typography } from 'antd';
import styled from 'styled-components';

export const DescriptionStyled = styled(Typography.Text)`
	font-size: 14px;
`;

export const CardStyled = styled(Card)`
	padding: 0;
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		height: 420px;
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		width: 332px;
		height: 472px;
	}

	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		width: 288px;
		height: 400px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		width: 282px;
		height: 400px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		width: 282px;
		height: 400px;
	}
`;

export const LogoCoverStyled = styled(`div`)`
	display: flex !important;
	justify-content: center;
	align-items: center;
	height: 240px;
	background-size: cover;
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		width: 332px;
		height: 332px;
	}

	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		width: 288px;
		height: 240px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		width: 282px;
		height: 240px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		width: 282px;
		height: 240px;
	}
`;

export const CardTextContainerStyled = styled(`div`)``;
export const CardHeaderStyled = styled(`h3`)`
	gap: 12px;
	display: flex;
	align-items: center;
	font-weight: 500;
	font-size: 20px;
	line-height: 28px;
`;
export const CardDescriptionStyled = styled(`p`)`
	color: #8c8c8c;
	font-weight: 250;
	font-size: 16px;
	line-height: 24px;
`;
